<template>
    <div
            id="app"
    >
        <div class="loading-parent">
            <loading :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage"
            >
                <h3 v-if="browserDetect.isIE || browserDetect.isEdge">{{ $t('message.Loading') }}</h3>
            </loading>
        </div>
        <div class="row mt-25 mb-50">
            <div class="product-price">
                <div class="col-xs-6">
                    <span class="fa fa-tag "></span>
                    <span class="price-sales">{{productPrice}}</span>
                </div>
                <div class="col-xs-6">
                    <div v-if="shippingPrice">
                        <span class="fa fa-truck "></span>
                        <span class="costospedizione">
                            {{shippingPrice}}
                        </span>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div v-if="itemAvailability">
                        <span style="font-size: small !important;">
                            {{ $t('message.availability') }} : {{itemAvailability}}
                        </span>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <span style="font-size: small !important;" v-if="itemAvailability">
                        <span class="fa fa-cubes"></span>
                             {{ $t('message.shipping_preparation') }} {{shippingTime}} {{ $t('message.days') }}
                    </span>
                </div>

            </div>
        </div>
        <div
                v-if="isFamily"
                class="row mt-25">
            <div class="col-xs-12">
                <div class="productFilter productFilterLook2">
                    <label> {{ $t('message.choose') }}</label>
                    <div class="filterBox">
                        <select
                                v-model="child"
                                :disabled="isLoading"
                                name="child"
                                id="child-picker"
                                @change="childSelected"
                                class="select-large"
                        >
                            <option value="---">  {{ $t('message.choose') }} </option>
                            <option
                                    v-for="(child) in childs"
                                    v-bind:value="child.sku_slug"
                                    style="font-size: 10px !important;"
                            >
                                {{child.child_description ? child.child_description : child.additional_description}}
                            </option>
                        </select>
                    </div>

                </div>
            </div>
        </div>
        <div v-if="isVariant"
             class="row mt-25">
            <div class="col-sm-6 col-xs-12">
                <div class="productFilter productFilterLook2">
                    <label v-if="!noVariants && isVariant">{{labelColor}}</label>
                    <label
                            v-if="noVariants && isVariant"
                            class="alert alert-warning">Errore durante il reperimento delle
                        varianti, contattare l'amministrazione</label>

                    <div v-if="length(colorsMap) > 1" class="filterBox">
                        <select
                                v-model="color"
                                :disabled="isLoading"
                                name="color"
                                id="color-picker"
                                @change="variantChange"
                                class="select-large"
                        >
                            <option value="---">  {{ $t('message.choose') }} </option>
                            <option
                                    v-for="(color, index) in getColors()"
                                    v-bind:value="color"
                                    style="color: #999 !important;"
                            >
                                {{colorsMap[color]}}
                            </option>
                        </select>
                    </div>
                    <div v-else class="filterBox">
                        <h3>{{colorsMap[color]}}</h3>
                    </div>

                </div>
            </div>
            <div class="col-sm-6 col-xs-12">
                <div class="productFilter productFilterLook2">
                    <label v-if="showLabelSize()">{{labelSize}}</label>

                    <div v-if="length(sizesMap) > 1" class="filterBox">
                        <select
                                v-model="size"
                                :disabled="isLoading && color"
                                name="size"
                                id="size"
                                @change="variantChange"
                                class="select-large"
                        >
                            <option
                                    v-for="(size, index) in getSizes(color)"
                                    v-bind:value="size"
                            >
                                {{sizesMap[size].label}}
                            </option>
                        </select>
                    </div>
                    <div v-else class="filterBox">
                        <h3 v-if="showLabelSize()">{{sizesMap[size].label}}</h3>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="itemAvailability" class="row mt-25 mb-50">
            <div class="col-sm-6 col-xs-12">
                <div class="productFilter productFilterLook2">
                    <div class="filterBox">
                        <label>{{ $t('message.quantity') }}</label>

                        <input
                                type="number"
                                name="quantity"
                                v-on:keyup="fetchShippingPrice"
                                v-model="ppQuantity"
                                id="quantity"
                                class="form-control"
                                autocomplete="off"
                                style="border: 1px solid #2d9b51;  line-height: 24px; color: #999"
                        >
                    </div>

                </div>
            </div>
            <div class="col-sm-6 col-xs-12">
                <div class="productFilter productFilterLook2 mt-25 cart-actions">
                    <div class="addto">
                        <form :action="getAddToCartLink" method="GET">
                            <button
                                    v-if="getAddToCartLink"
                                    class="button btn-block btn-cart cart first"
                                    title="$t('message.add_to_cart')"
                                    type="submit">{{ $t('message.add_to_cart') }}
                            </button>
                            <button
                                    v-else

                                    disabled
                                    class="button btn-block btn-default"
                                    title="$t('message.add_to_cart')"
                                    type="button">{{ $t('message.add_to_cart') }}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>

            <div v-if="quantity && itemAvailability && itemAvailability < quantity" value="col-xs-12">
                <div class="alert alert-danger">
                    {{ $t('message.quantity_no_available') }}
                </div>
            </div>
        </div>
        <div v-else-if="isVariant && variantCode && !itemAvailability &&!isLoading" class="row mt-25 mb-50">
            <div class="col-xs-12">
                <div class="alert alert-danger">
                    {{ $t('message.product_no_available') }}
                </div>
            </div>
        </div>
        <div v-else-if="isFamily && child && !itemAvailability &&!isLoading" class="row mt-25 mb-50">
            <div class="col-xs-12">
                <div class="alert alert-danger">
                    {{ $t('message.product_no_available') }}
                </div>
            </div>
        </div>

        <div v-else-if="isSingle && !itemAvailability &&!isLoading" class="row mt-25 mb-50">
            <div class="col-xs-12">
                <div class="alert alert-danger">
                    {{ $t('message.product_no_available') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Loading from 'vue-loading-overlay';
    import Vue from 'vue'

    Vue.use(Loading);
    Vue.component('loading', Loading);

    export default {
        name: 'app',
        components: {},
        data() {
            return {
                locale: this.$i18n.locale,
                browserDetect: this.$browserDetect,
                sku: null,
                noVariants: null,
                um: null,
                itemAvailability: null,
                productPrice: null,
                defaultPrice: null,
                shippingPrice: null,
                defaultShippingPrice: null,
                shippingPriceIncluded: null,
                shippingTime: null,
                labelColor: null,
                labelSize: null,
                isVariant: null,
                isFamily: null,
                isSingle: null,
                isLoadingProduct: false,
                isLoadingVariants: false,
                isLoadingShippingCosts: false,
                isLoadingVariantPrice: false,
                isLoadingVariantAvailability: false,
                isLoadingProductAvailability: false,
                isLoadingFamily: false,
                fullPage: true,
                variants: [],
                colorsMap: {},
                sizesMap: {},
                colors: [],
                sizes: [],
                childs: [],
                colorsBySize: {},
                sizesByColor: {},
                color: null,
                size: null,
                child: null,
                quantity: null,
                variantCode: null,
                language: this.$route.params['lang']
            }
        },
        computed: {
            isLoading() {
                return (
                    this.isLoadingProduct ||
                    this.isLoadingVariants ||
                    this.isLoadingShippingCosts ||
                    this.isLoadingVariantPrice ||
                    this.isLoadingVariantAvailability ||
                    this.isLoadingProductAvailability ||
                    this.isLoadingFamily
                );
            },
            getAddToCartLink() {

                if (this.isLoading) {
                    return '';
                }
                let cartUrl = '';

                if (this.isVariant) {

                    if (this.color && this.size && this.quantity && this.itemAvailability && this.itemAvailability >= this.quantity) {

                        cartUrl = '/' +
                            this.$route.params['lang'] +
                            '/add-to-cart/' +
                            this.sku +
                            '/' +
                            this.um +
                            '/' +
                            this.quantity +
                            '/' +
                            this.color + '-' + (this.size).replace("/", '^')
                        ;
                    }

                }

                if (this.isFamily) {

                    if (this.child && this.quantity && this.itemAvailability && this.itemAvailability >= this.quantity) {

                        cartUrl =
                            '/' +
                            this.$route.params['lang'] +
                            '/add-to-cart/' +
                            this.child +
                            '/' +
                            this.um +
                            '/' +
                            this.quantity
                        ;
                    }

                }

                if (this.isSingle) {

                    if (this.quantity && this.itemAvailability && this.itemAvailability >= this.quantity) {
                        cartUrl =
                            '/' +
                            this.$route.params['lang'] +
                            '/add-to-cart/' +
                            this.sku +
                            '/' +
                            this.um +
                            '/' +
                            this.quantity
                        ;
                    }

                }


                return cartUrl;
            },
            ppQuantity: {
                get() {
                    return this.quantity;
                },
                set(val) {
                    this.quantity = '';
                    this.$nextTick(() => {
                        this.quantity = val.replace('.', '');
                    });
                }
            }
        },
        methods: {

            length(obj) {
                var size = 0, key;
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) size++;
                }
                return size;
            },
            variantChange(event) {
                if (this.color === '---') {
                    this.color = null;
                }

                if (this.color && this.size) {
                    this.variantCode = this.color + '-' + this.size;
                    this.fetchVariantPrice();
                }

            },
            childSelected(event) {
                let childSelected = this.childs.filter((child) => (
                    child.sku_slug === event.target.value
                ));

                if (childSelected && childSelected[0]) {
                    childSelected = childSelected[0];
                    if (childSelected) {

                        this.sku = encodeURI(childSelected.sku_slug);

                        if (childSelected.ecommerce) {
                            this.productPrice = childSelected.ecommerce.price;
                            this.shippingTime = childSelected.ecommerce.web_shipping_time;
                            this.um = childSelected.base_unit_of_measure;
                        } else {
                            this.productPrice = 'n.d.';
                            this.shippingPrice = 'n.d.';
                        }
                    } else {
                        this.productPrice = 'n.d.';
                        this.shippingPrice = 'n.d.';
                    }
                } else {
                    this.productPrice = this.defaultPrice;
                    this.shippingPrice = this.defaultShippingPrice;
                    this.child = null;
                    this.um = null;
                }

                this.fetchShippingPrice();
                this.isLoadingProductAvailability = true;

                this.axios
                    .get(process.env.VUE_APP_API_BASE_URL + '/acm3-ecommerce/api/getProductAvailabilityBySkuSlug', {
                        params: {
                            'sku': this.sku,
                            'language': this.$route.params['lang']
                        }
                    })
                    .then(response => {
                        this.itemAvailability = response.data.itemAvailability;
                        this.isLoadingProductAvailability = false;
                    })
                    .catch(reason => {
                        this.itemAvailability = 0;
                        this.isLoadingProductAvailability = false;
                    });

            },
            _fetchVariants() {
                this.colorsMap = {};
                this.isLoadingVariants = true;
                this.axios
                    .get(process.env.VUE_APP_API_BASE_URL + '/acm3-ecommerce/api/getVariantsBySkuSlug', {
                        params: {
                            'sku': this.sku,
                            'language': this.$route.params['lang']
                        }
                    })
                    .then(response => {
                        if (response.data && response.data.variants && response.data.variants.length) {
                            this.noVariants = false;
                            this.variants = response.data.variants;

                            this.labelColor = response.data.folder_label;
                            this.labelSize = response.data.size_label;

                            this.populateVariants();
                            this.variantChange(null);
                        } else {
                            this.noVariants = true;
                            this._fetchChilds();
                        }

                        this.isLoadingVariants = false;
                    });
            },
            _fetchChilds() {

                this.childs = [];
                this.isLoadingFamily = true;
                this.axios
                    .get(process.env.VUE_APP_API_BASE_URL + '/acm3-ecommerce/api/getFamilyBySkuSlug', {
                        params: {
                            'sku': this.sku,
                            'language': this.$route.params['lang']
                        }
                    })
                    .then(response => {
                        if (response.data) {
                            this.childs = response.data;
                        }

                        this.isLoadingFamily = false;
                    });
            },
            fetchVariantPrice() {

                if (this.sku && this.variantCode) {
                    this.isLoadingVariantPrice = true;

                    this.axios
                        .get(process.env.VUE_APP_API_BASE_URL + '/acm3-ecommerce/api/getProductVariantPriceBySkuSlug', {
                            params: {
                                'sku': this.sku,
                                'variant': this.variantCode,
                                'language': this.$route.params['lang']
                            }
                        })
                        .then(response => {
                            this.productPrice = response.data.price;
                            this.isLoadingVariantPrice = false;
                        });

                    this.isLoadingVariantAvailability = true;

                    this.axios
                        .get(process.env.VUE_APP_API_BASE_URL + '/acm3-ecommerce/api/getProductVariantAvailabilityBySkuSlug', {
                            params: {
                                'sku': this.sku,
                                'variant': this.variantCode,
                                'language': this.$route.params['lang']
                            }
                        })
                        .then(response => {
                            this.itemAvailability = response.data.itemAvailability;
                            this.isLoadingVariantAvailability = false;
                        })
                        .catch(reason => {
                            this.itemAvailability = 0;
                            this.isLoadingVariantAvailability = false;
                        });

                }
            },
            fetchShippingPrice() {

                if (!this.quantity) {
                    return;
                }

                this.isLoadingShippingCosts = true;

                this.axios
                    .get(process.env.VUE_APP_API_BASE_URL + '/acm3-ecommerce/api/getShippingCostsBySkuSlug', {
                        params: {
                            'sku': this.sku,
                            'quantity': this.quantity,
                            'language': this.$route.params['lang']
                        }
                    })
                    .then(response => {
                        this.shippingPrice = response.data;
                        this.free = response.data;
                        this.isLoadingShippingCosts = false;
                    });

            },
            populateVariants() {
                this.colorsMap = {};
                this.sizesMap = {};
                this.variants.forEach(function (item) {
                    const codes = item.Code.split("-");

                    if (!this.colorsBySize.hasOwnProperty(codes[1])) {
                        this.colorsBySize[codes[1]] = [];
                    }
                    if (!this.sizesByColor.hasOwnProperty(codes[0])) {
                        this.sizesByColor[codes[0]] = [];
                    }

                    this.colorsMap[codes[0]] = item["label"];
                    this.sizesMap[codes[1]] = {
                        id: codes[1],
                        label: item["SizeName"]
                    };

                    this.colorsBySize[codes[1]].push(codes[0]);
                    this.sizesByColor[codes[0]].push(codes[1]);


                }, this);

                if (Object.keys(this.colorsMap).length === 1) {
                    let key = Object.keys(this.colorsMap);
                    this.color = key[0];

                    if (Object.keys(this.sizesByColor[key[0]]).length === 1) {
                        let keySize = this.sizesByColor[key[0]];
                        this.size = keySize[0];
                    }
                }
                if (Object.keys(this.sizesMap).length === 1) {
                    this.size = this.sizesMap[Object.keys(this.sizesMap)[0]].id;
                }
            },

            getSizes(color) {
                return this.sizesByColor.hasOwnProperty(color) ? this.sizesByColor[color] : [];
            },
            getColors(size) {
                if (size) {
                    return this.colorsBySize.hasOwnProperty(size) ? this.colorsBySize.size : [];
                }
                return Object.keys(this.sizesByColor);
            },
            showLabelSize() {
                let objSize = this.sizesMap[Object.keys(this.sizesMap)[0]];

                if (this.length(this.sizesMap) === 1) {
                    if (typeof objSize != 'undefined' && objSize.id === "0") {
                        return false
                    }
                }

                return typeof objSize != 'undefined';
            }

        },
        created() {

            const BASE_URL = `${process.env.VUE_APP_API_BASE_URL}`;

            const CONFIG = {
                baseURL: BASE_URL,
                headers: {
                    Authorization: '',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                /*
                transformRequest: [
                    addAuthToken,
                ],
                */
            };

            this.axios.create(CONFIG);
        },
        mounted() {

            this.$i18n.locale = this.$route.params.lang;

            this.sku = this.$route.params.sku;

            this.color = null;
            this.size = null;
            this.quantity = 1;

            this.isLoadingProduct = true;

            this.axios
                .get(process.env.VUE_APP_API_BASE_URL + '/acm3-ecommerce/api/getProductBySkuSlug', {
                    params: {
                        'sku': this.sku,
                        'language': this.$route.params['lang']
                    }
                })
                .then(response => {
                    this.isLoadingProduct = false;

                    this.um = response.data.base_unit_of_measure;
                    this.productPrice = response.data.ecommerce.price;
                    this.shippingPriceIncluded = response.data.ecommerce.free_transport;
                    //this.shippingPrice = response.data.ecommerce.transport_price;
                    this.shippingTime = response.data.ecommerce.web_shipping_time;

                    this.isSingle = response.data.mode === 'single';
                    this.isVariant = response.data.mode === 'variant';
                    this.isFamily = response.data.mode === 'family';

                    this.isVariant ? this._fetchVariants() : null;
                    this.isFamily ? this._fetchChilds() : null;

                    if (!this.isFamily) {
                        this.fetchShippingPrice()
                    }

                    if (this.isSingle) {
                        this.isLoadingProductAvailability = true;

                        this.axios
                            .get(process.env.VUE_APP_API_BASE_URL + '/acm3-ecommerce/api/getProductAvailabilityBySkuSlug', {
                                params: {
                                    'sku': this.sku,
                                    'language': this.$route.params['lang']
                                }
                            })
                            .then(response => {
                                this.itemAvailability = response.data.itemAvailability;
                                this.isLoadingProductAvailability = false;
                            })
                            .catch(reason => {
                                this.itemAvailability = 0;
                                this.isLoadingProductAvailability = false;
                            });

                    }
                })
                .catch(reason => {
                    this.itemAvailability = 0;
                    this.isLoadingProduct = false;
                });


        }
    }

    import 'vue-loading-overlay/dist/vue-loading.css';

</script>

<style>
</style>
